import { render, staticRenderFns } from "./shenheDialog.vue?vue&type=template&id=58728ed7"
import script from "./shenheDialog.vue?vue&type=script&lang=js"
export * from "./shenheDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports